<div class="position-absolute pos-bottom pos-left pos-right p-3 text-center text-white" id="footer">
    2020 © English Coffee by&nbsp;<a href='http://www.englishcoffee.com.br' class='text-white opacity-40 fw-500' title='englishcoffee.com.br' target='_blank'>englishcoffee.com.br</a>
</div>
